// WO-V5-B (US-029.3) — « mon quota ». Module dédié (et non ajouté à
// `adminModelsQuotasAndCollabApi.ts`) : cette route est lisible par TOUT membre, alors que
// tout le reste de ce fichier voisin est réservé à `config.manage` — les mélanger aurait
// rendu la frontière de permission invisible à la lecture du code.
import { request } from './http'
import type { MonQuota, OrganisationPlan } from './types/quota'

export const quotaApi = {
  /** `GET /api/v1/workspaces/{id}/quota` — tout membre (owner/contributor/viewer). */
  monQuota: (workspaceId: string) =>
    request<MonQuota>(`/workspaces/${encodeURIComponent(workspaceId)}/quota`),

  /**
   * WO-V7-A2 (HD-12) — `GET /api/v1/organisations/{id}/plan` : palier courant de
   * l'organisation, lisible par tout membre de SA PROPRE organisation (ou la
   * plateforme pour une organisation arbitraire, cf. `OrganisationPlanController`).
   */
  organisationPlan: (organisationId: string) =>
    request<OrganisationPlan>(`/organisations/${encodeURIComponent(organisationId)}/plan`),
}
